var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLanguage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9.925 5.281A9.41 9.41 0 0 0 9.51 7m0 0c-.127.816-.19 1.707-.197 2.586M9.51 7h2.24M9.51 7H7.475m1.838 2.586c-.011 1.48.136 2.923.4 3.899m-.4-3.899c-3.49.5-3.307 3.95-.111 3.95.174 0 .345-.018.51-.051m-.399-3.899c.273-.039.567-.06.885-.06.906 0 1.71.218 2.325.597m-2.81 3.362c.063.238.135.448.212.624m-.213-.624c1.655-.334 2.811-2.224 2.811-3.362m0 0c.774.476 1.248 1.207 1.248 2.077m-1.248-2.077c.124-.67.124-1.17.124-1.17m.83 9.01.773-1.588m0 0h4.633m-4.633 0 2.317-4.766 2.316 4.766m0 0 .772 1.589M17 2H9C5 2 3 4 3 8v7.102l-1.935 4.033A2 2 0 0 0 2.868 22H17c3.977 0 6-2 6-6V8c0-3.875-2-6-6-6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguage);
export default __webpack_public_path__ + "static/media/language.5f9c70920495f71bc74c7150ff535ab6.svg";
export { ForwardRef as ReactComponent };